import { render, staticRenderFns } from "./CovidQuestionnaire.vue?vue&type=template&id=45b35cc8&scoped=true&"
import script from "./CovidQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./CovidQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b35cc8",
  null
  
)

export default component.exports